import WorkspacePreviewBreakpoints from "../../../../src/components/WorkspacePreviewBreakpoints";
import * as React from 'react';
export default {
  WorkspacePreviewBreakpoints,
  React
};